import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
	id: '',
	image: '',
	userName: '',
	name: '',
	surname: '',
	email: '',
	role: 'user',
	authority: []
}

export const userSlice = createSlice({
	name: 'auth/user',
	initialState,
	reducers: {
		setAdmin: (state, action) => {
			state.id = action.payload.id
			state.image = action.payload.image
			state.userName = action.payload.userName
			state.name = action.payload.name
			state.surname = action.payload.surname
			state.email = action.payload.email
			state.role = action.payload.role
			state.authority = action.payload.authority
		},
        adminLoggedOut: () => initialState,
	},
})

export const { setAdmin } = userSlice.actions

export default userSlice.reducer
